"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Role = void 0;
var tslib_1 = require("tslib");
var User_1 = require("./User");
var Entity_1 = require("./Entity");
var enumerable_1 = require("../util/enumerable");
var Role = /** @class */ (function (_super) {
    tslib_1.__extends(Role, _super);
    function Role() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * A set of users which have this role
         */
        _this.users = null;
        /**
         * The name of the role
         */
        _this.name = null;
        return _this;
    }
    /**
     * Test if the given user has this role
     * @param user The user to check
     * @return <code>true</code> if the given user has this role,
     * otherwise <code>false</code>
     */
    Role.prototype.hasUser = function (user) {
        return !!this.users && this.users.has(user);
    };
    /**
     * Add the given user to this role
     * @param user The user to add
     */
    Role.prototype.addUser = function (user) {
        if (user instanceof User_1.User) {
            if (!this.users) {
                this.users = new Set();
            }
            this.users.add(user);
        }
        else {
            throw new Error('Only user instances can be added to a role.');
        }
    };
    /**
     * Remove the given user from this role
     * @param user The user to remove
     */
    Role.prototype.removeUser = function (user) {
        if (user instanceof User_1.User) {
            if (this.users) {
                this.users.delete(user);
            }
        }
        else {
            throw new Error('Only user instances can be removed from a role.');
        }
    };
    tslib_1.__decorate([
        (0, enumerable_1.enumerable)(false)
    ], Role.prototype, "hasUser", null);
    tslib_1.__decorate([
        (0, enumerable_1.enumerable)(false)
    ], Role.prototype, "addUser", null);
    tslib_1.__decorate([
        (0, enumerable_1.enumerable)(false)
    ], Role.prototype, "removeUser", null);
    return Role;
}(Entity_1.Entity));
exports.Role = Role;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUm9sZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIlJvbGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7OztBQUNBLCtCQUE4QjtBQUM5QixtQ0FBa0M7QUFDbEMsaURBQWdEO0FBRWhEO0lBQTBCLGdDQUFNO0lBQWhDO1FBQUEscUVBcURDO1FBcERDOztXQUVHO1FBQ0ksV0FBSyxHQUEyQixJQUFJLENBQUM7UUFFNUM7O1dBRUc7UUFDSSxVQUFJLEdBQWtCLElBQUksQ0FBQzs7SUE0Q3BDLENBQUM7SUExQ0M7Ozs7O09BS0c7SUFFSCxzQkFBTyxHQUFQLFVBQVEsSUFBZ0I7UUFDdEIsT0FBTyxDQUFDLENBQUMsSUFBSSxDQUFDLEtBQUssSUFBSSxJQUFJLENBQUMsS0FBSyxDQUFDLEdBQUcsQ0FBQyxJQUFJLENBQUMsQ0FBQztJQUM5QyxDQUFDO0lBRUQ7OztPQUdHO0lBRUgsc0JBQU8sR0FBUCxVQUFRLElBQWdCO1FBQ3RCLElBQUksSUFBSSxZQUFZLFdBQUksRUFBRTtZQUN4QixJQUFJLENBQUMsSUFBSSxDQUFDLEtBQUssRUFBRTtnQkFDZixJQUFJLENBQUMsS0FBSyxHQUFHLElBQUksR0FBRyxFQUFFLENBQUM7YUFDeEI7WUFFRCxJQUFJLENBQUMsS0FBSyxDQUFDLEdBQUcsQ0FBQyxJQUFJLENBQUMsQ0FBQztTQUN0QjthQUFNO1lBQ0wsTUFBTSxJQUFJLEtBQUssQ0FBQyw2Q0FBNkMsQ0FBQyxDQUFDO1NBQ2hFO0lBQ0gsQ0FBQztJQUVEOzs7T0FHRztJQUVILHlCQUFVLEdBQVYsVUFBVyxJQUFnQjtRQUN6QixJQUFJLElBQUksWUFBWSxXQUFJLEVBQUU7WUFDeEIsSUFBSSxJQUFJLENBQUMsS0FBSyxFQUFFO2dCQUNkLElBQUksQ0FBQyxLQUFLLENBQUMsTUFBTSxDQUFDLElBQUksQ0FBQyxDQUFDO2FBQ3pCO1NBQ0Y7YUFBTTtZQUNMLE1BQU0sSUFBSSxLQUFLLENBQUMsaURBQWlELENBQUMsQ0FBQztTQUNwRTtJQUNILENBQUM7SUFsQ0Q7UUFEQyxJQUFBLHVCQUFVLEVBQUMsS0FBSyxDQUFDO3VDQUdqQjtJQU9EO1FBREMsSUFBQSx1QkFBVSxFQUFDLEtBQUssQ0FBQzt1Q0FXakI7SUFPRDtRQURDLElBQUEsdUJBQVUsRUFBQyxLQUFLLENBQUM7MENBU2pCO0lBQ0gsV0FBQztDQUFBLEFBckRELENBQTBCLGVBQU0sR0FxRC9CO0FBckRZLG9CQUFJIn0=